import { Box, Txt } from '@stenajs-webui/core';
import { FlatButton, stenaQuestionCircle } from '@stenajs-webui/elements';
import { FreightPortalPopover } from './popover/FreightPortalPopover';
import { PopoverBody } from './popover/PopoverBody';
import { PopoverTitle } from './popover/PopoverTitle';

interface HelpPopoverProps {
  descriptionText: string;
  headerText: string;
  tabIndex?: number;
}

export function HelpPopover({ tabIndex, headerText, descriptionText }: HelpPopoverProps) {
  return (
    <FreightPortalPopover
      placement={'right'}
      renderTrigger={triggerProps => (
        <FlatButton
          {...triggerProps}
          tabIndex={tabIndex}
          leftIcon={stenaQuestionCircle}
          size={'small'}
        />
      )}
    >
      {({ onRequestClose }) => (
        <Box minWidth={240} maxWidth={320}>
          <PopoverTitle text={headerText} onClose={onRequestClose} />
          <PopoverBody gap>
            <Txt>{descriptionText}</Txt>
          </PopoverBody>
        </Box>
      )}
    </FreightPortalPopover>
  );
}
